<template>
<v-card flat color="rgb(81, 167, 248, .1)" height="74" width="200">
    <v-card-text class="d-flex align-center">
          <v-avatar rounded color="white">
            <v-icon color="titleText"> mdi-chart-line </v-icon>
          </v-avatar>
          <div class="ml-3">
            <h4 class="darkGrey--text">MAPE</h4>
            <h3 class="blue--text">
              {{this.MAPE}}%
            </h3>
          </div>
    </v-card-text>
  </v-card>
</template>

<script>


export default ({
     props: {
    divdata: [],
  },
    data: () => ({

        MAPE: '',
         tempctrldata: [],
    }),
    methods: {
        getdivtext() {
      this.MAPE = 0;
      let temp = [];
      temp = this.tempctrldata;
      this.MAPE= temp.filter((a) => a.region == "national")[0].mape;
    }
    },
    mounted() {
    this.tempctrldata = this.divdata;
  this. getdivtext();
   // this.getroi_activity();
    //this.binddata();
   
  },
  watch: {
    divdata: function (val) {
     // alert("Onoad -" + val);
      if (val) {
        this.tempctrldata = this.divdata;
    this.getdivtext();
      }
    },
  },
})
</script>

<style scoped>

headerbox {
    font-weight: bold;
    font-style: italic;
    font-size: 20px;
    color: gray;
}

.headerboxtitle {

    font-size: 20px; 
    color: gray;
    text-align: center;
     font-style: italic;
      font-weight: bold;
  
}
.card3{
background-color: #ffc107;

}
</style>
